$(document).ready(function () {
    if ($('.services__tabs').length > 0) {
        $('.services__tabs .tabs__titles .tab__title').click(function() {
            let datacontrolled = $(this).attr('data-control');
            $('.services__tabs .tabs__titles .tab__title').removeClass('active');
            $(this).addClass('active');

            $('.tabs__content .tab__content').removeClass('active').hide();
            $('.tabs__content .tab__content[data-controlled=' + datacontrolled + ']').fadeIn().addClass('active');
        });
    }
});